/**
 * @param {string} value
 * @return {boolean}
 */

export function isValidNoSymbol(value) { // 不可含空格和任何特殊符號
  const regex = /^((?!\s)(?!\.)(?!,)(?!\+)(?!\*)(?!\?)(?!\^)(?!\$)(?!\[)(?!\])(?!\{)(?!\})(?!\()(?!\))(?!\^)(?!\|)(?!\\)(?!\/).)*$/;
  return regex.test(value);
}

export function isValidRequired(value) { // 不可含空格和任何特殊符號
  return value && value.trim() ? true : false;
}

export function isValidString(value) { // 不含特殊符號和全形符號
  return isValidNoSymbol(value) && isValidHalfwidth(value) && isValidRequired(value);
}

export function isValidGender(value) {
  const regex = /^(Male|Female)$/;
  return regex.test(value);
}

export function isValidPhone(value) {
  const regex = /^[-0-9#]{6,19}$/;
  return regex.test(value);
}

export function isValidCreditCard(value) { // 合法的信用卡，正常是16碼(目前不支援通運15碼)
  return Number(value) && Number(value.trim()) && value.length == 16 ? true : false;
}

export function isValidAmount(value) {
  return Number(value) && Number(value.trim()) ? true : false;
}

export function isValidEmail(value) {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(value).toLowerCase());
}

export function isValidName(value) { // 合法的名稱
  const regex = /\d|\s/; // 不可含數字與空格
  return !regex.test(value);
}

export function isValidID(value) { // 6-20 個數字或英文大寫字母
  const regex = /^(([A-Z0-9]{6,20}))$/;
  return regex.test(value);
}

export function isValidTwID(value) { // 合法的台灣身分證
  const regex = /^(([A-Z]{1}[1-2]{1}[0-9]{8}))$/;
  return regex.test(value);
}

export function isValidtaxID(value) { // 合法的統編
  const regex = /^[0-9]*$/;
  return value.length === 8 && regex.test(value);
}

export function isValidHalfwidth(value) {
  // 全形英文小寫 [\uFF41-\uFF5A]
  // 全形英文大寫 [\uFF21-\uFF3A]
  // 全形數字 [\uFF10-\uFF19]
  // 全行括號 \uff08,\uff09
  // [^ 表示不包含
  const regex = /^([^\uFF41-\uFF5A\uFF21-\uFF3A\uFF10-\uFF19\uff08\uff09\s]*)$/;
  return regex.test(value);
}

export function isValidAddress(value) {
  const regex = /^(.){4,64}$/; // 至少要有四個字
  return regex.test(value);
}

export function isValidCreditCardExpire(value) { // 合法的信用卡過期碼
  const month = Number(value[0] + value[1]);
  return value.length === 4 && month <= 12;
}

export function isValidOption(value) { // 有選擇選項
  return value && value.trim() ? true : false;
}